// extracted by mini-css-extract-plugin
export var dividerContainer = "_7k-0";
export var line = "_7k-1";